"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var LinkButton_1 = __importDefault(require("./styledComponents/LinkButton"));

var BulkDocumentDownload_meta_1 = require("./BulkDocumentDownload.meta");

var Link_1 = __importDefault(require("../../base/Link"));

var ACCEPT_KEYS = [shared_1.KEYS.ENTER, shared_1.KEYS.SPACE, shared_1.KEYS.SPACEBAR];

var BulkDocumentDownload = function (_super) {
  __extends(BulkDocumentDownload, _super);

  function BulkDocumentDownload(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = BulkDocumentDownload_meta_1.BULK_DOCUMENT_DOWNLOAD_CATEGORY_KEY;
    _this.componentKey = BulkDocumentDownload_meta_1.BULK_DOCUMENT_DOWNLOAD_COMPONENT_KEY;

    _this.onClick = function (e) {
      _this.handleDownload();
    };

    _this.onKeyUp = function (e) {
      var key = e.key;

      if (ACCEPT_KEYS.indexOf(key) !== -1) {
        _this.handleDownload();
      }
    };

    _this.handleDownload = function () {
      var _a = _this.props,
          documentIds = _a.documentIds,
          onDownloadClick = _a.onDownloadClick;

      if (onDownloadClick) {
        onDownloadClick(documentIds);
      }
    };

    return _this;
  }

  BulkDocumentDownload.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        label = _a.label;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, react_1.default.createElement(LinkButton_1.default, null, react_1.default.createElement(Link_1.default, {
      role: "button",
      tabIndex: 0,
      onClick: this.onClick,
      onKeyUp: this.onKeyUp
    }, label)));
  };

  BulkDocumentDownload = __decorate([mobx_react_1.observer], BulkDocumentDownload);
  return BulkDocumentDownload;
}(shared_1.ComponentBase);

exports.BulkDocumentDownload = BulkDocumentDownload;
exports.default = shared_1.InjectedStyledComponent(BulkDocumentDownload, BulkDocumentDownload_meta_1.BULK_DOCUMENT_DOWNLOAD_CATEGORY_KEY, BulkDocumentDownload_meta_1.BULK_DOCUMENT_DOWNLOAD_COMPONENT_KEY);